import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FiGlobe, FiMenu, FiX } from 'react-icons/fi';
import './Navigation.css';

const Navigation = ({ content, languageLabel, onToggleLanguage }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 24);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setIsMobileMenuOpen(false);
    const target = document.querySelector(href);

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <motion.nav
      className={`navigation ${isScrolled ? 'scrolled' : ''}`}
      initial={{ y: -90 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.45 }}
    >
      <div className="nav-container">
        <button className="nav-brand" onClick={() => handleNavClick('#home')}>
          <span>Icaro Felipe de Lanes</span>
          <small>{content.brandRole}</small>
        </button>

        <div className="nav-menu desktop">
          {content.items.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="nav-item"
              onClick={(event) => {
                event.preventDefault();
                handleNavClick(item.href);
              }}
            >
              {item.name}
            </a>
          ))}
        </div>

        <div className="nav-actions">
          <button
            className="language-toggle"
            onClick={onToggleLanguage}
            aria-label="Toggle language"
          >
            <FiGlobe />
            {languageLabel}
          </button>

          <button
            className="mobile-menu-button"
            onClick={() => setIsMobileMenuOpen((current) => !current)}
            aria-label="Toggle navigation"
          >
            {isMobileMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>

        <motion.div
          className={`nav-menu mobile ${isMobileMenuOpen ? 'open' : ''}`}
          initial={false}
          animate={{
            opacity: isMobileMenuOpen ? 1 : 0,
            y: isMobileMenuOpen ? 0 : -10,
          }}
          transition={{ duration: 0.22 }}
        >
          {content.items.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="nav-item"
              onClick={(event) => {
                event.preventDefault();
                handleNavClick(item.href);
              }}
            >
              {item.name}
            </a>
          ))}
        </motion.div>
      </div>
    </motion.nav>
  );
};

export default Navigation;
